/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlLocation
 */
export interface ControlLocation {
    /**
     * 
     * @type {string}
     * @memberof ControlLocation
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlLocation
     */
    continent?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlLocation
     */
    continentCode?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlLocation
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlLocation
     */
    countryCode?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlLocation
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof ControlLocation
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof ControlLocation
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ControlLocation
     */
    lat?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlLocation
     */
    lon?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlLocation
     */
    state?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlLocation
     */
    teamId: string;
}

/**
 * Check if a given object implements the ControlLocation interface.
 */
export function instanceOfControlLocation(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "displayName" in value;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "teamId" in value;

    return isInstance;
}

export function ControlLocationFromJSON(json: any): ControlLocation {
    return ControlLocationFromJSONTyped(json, false);
}

export function ControlLocationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlLocation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'city': !exists(json, 'city') ? undefined : json['city'],
        'continent': !exists(json, 'continent') ? undefined : json['continent'],
        'continentCode': !exists(json, 'continentCode') ? undefined : json['continentCode'],
        'country': !exists(json, 'country') ? undefined : json['country'],
        'countryCode': !exists(json, 'countryCode') ? undefined : json['countryCode'],
        'createdAt': json['createdAt'],
        'displayName': json['displayName'],
        'id': json['id'],
        'lat': !exists(json, 'lat') ? undefined : json['lat'],
        'lon': !exists(json, 'lon') ? undefined : json['lon'],
        'state': !exists(json, 'state') ? undefined : json['state'],
        'teamId': json['teamId'],
    };
}

export function ControlLocationToJSON(value?: ControlLocation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'city': value.city,
        'continent': value.continent,
        'continentCode': value.continentCode,
        'country': value.country,
        'countryCode': value.countryCode,
        'createdAt': value.createdAt,
        'displayName': value.displayName,
        'id': value.id,
        'lat': value.lat,
        'lon': value.lon,
        'state': value.state,
        'teamId': value.teamId,
    };
}

